<template>
  <div>
    <transition name="intake" mode="out-in">
      <ul v-if="!openSearch">
        <li v-if="search" class="service-item" @click="setOpenSearch">
          <div 
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            class="h2 service-item__link fw-medium">
            <span class="service-item__title">Find your Carelon</span>
            <img class="service-item__icon" :src="icon" >
          </div>
        </li>
        <p
          class="p small mb0"
          v-if="copy.show && services.length > 1"
        >Other ways we can help:</p>
        <module-service-item
          v-for="(service, key) in sortedServices"
          :key="key"
          :hide="service.hide"
          :arrow="true"
          :service="service"
        />
      </ul>
    </transition>
    
    <transition name="intake" mode="out-in">
      <form @submit.prevent="searchOrgs" class="form-fieldset" v-if="openSearch">
        <div class="form-fieldset__wrapper">
          <label for="search" :class="['form-label', { 'form-label--focus' : searchMsg.length > 0 }]">
            <span class="form-label__label p">Search your company name</span>
          </label>
          <div :class="['form-field df aic', { 'form-field--focus' : searchMsg.length > 0 }]">
            <input
              v-model="searchMsg"
              id="search"
              placeholder="Search your company name"
              type="text"
              class="form-input form-input--text"
            >
            <button class="home-search__btn" type="submit">Search</button>
          </div>
          <span v-show="errorMsg" class="form-error">
            <span
              class="small form-error__error"
              v-html="errorMsg"
            />
          </span>
        </div>
      </form>
    </transition>

    <module-dots v-if="searching" :active="true" />

    <transition name="intake" mode="out-in">
      <p class="mb2 mt2 p small" v-if="formattedOrgResults.length > 0 && !searching">{{ formattedOrgResults.length }} results for "{{ query }}"</p>
    </transition>

    <transition name="intake" mode="out-in">
      <ul
        v-if="formattedOrgResults.length > 0 && !searching"
        :class="[
          'list-provider',
          {
            'list-provider--search-open': openSearch
          }
        ]"
      >
        <li
          v-for="(org, index) in formattedOrgResults"
          :key="index"
          class="list-provider__item"
        >
          <a :href="`//${org.domain}`" class="list-provider__content tdn">
            <div class="list-provider__provider par">
              <span v-if="index === 0" class="list-provider__pill">Top match</span>
              <h2 class="h2 list-provider__title">{{ org.location }}</h2>
              <span class="fw-bold c-mid">{{ org.domain }}</span>
            </div>
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import ModuleServiceItem from 'components/ServiceItem';
import ModuleDots from 'components/Dots';

import arrow from 'images/icons/arrow-right.svg';

import TransitionExpandHeight from 'components/ExpandHeight';

import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    ModuleServiceItem,
    ModuleDots,
    TransitionExpandHeight,
  },

  props: {
    services: Array,
    copy: Object,
    search: Boolean,
    isSearching: Boolean,
    hr: Boolean,
  },

  data() {
    return {
      icon: arrow,
      openSearch: false,
      searchMsg: '',
      errorMsg: null,
      searching: false,
      query: null,
    };
  },

  computed: {
    ...mapGetters('app', ['org']),
    ...mapGetters('app', ['orgResults']),

    sortedServices() {
      return _.sortBy(this.services, ['sort_order']);
    },

    formattedOrgResults() {
      return _.filter(this.orgResults, (org) => org.location !== null);
    },
  },

  methods: {
    ...mapActions('app', ['requestSearchOrg']),

    setOpenSearch() {
      this.openSearch = true;
      this.$emit('isSearching', true);
    },

    searchOrgs() {
      if (this.searchMsg.length >= 5) {
        this.searching = true;
        this.errorMsg = null;
        this.requestSearchOrg(this.searchMsg)
          .then((r) => {
            this.query = this.searchMsg;
            if (r.data.results.length === 0 || this.formattedOrgResults.length === 0) {
              this.errorMsg = `No companies found for <b>"${this.searchMsg}"</b>`;
            }
            this.searching = false;
          });
      } else {
        this.errorMsg = 'Enter a minimum of 5 characters';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// NavLinks.vue?d5a405e4